import React from 'react';

import ThemeSwitch from "./ThemeSwitch"

import {useSetTheme} from "@view/theme/hooks/useTheme";
import {useThemeContext} from "@view/theme/context/hooks/useThemeContext";

const ToggleThemeMode = () => {
    const {setTheme} = useSetTheme()
    const {theme} = useThemeContext()
    const onChange = () => {
        const newTheme = theme === 'dark' ? 'light' : 'dark'
        setTheme(newTheme)
    }
    return (
        <ThemeSwitch
            checked={theme === 'dark'}
            onChange={onChange}
        />
    );
};

export default ToggleThemeMode;